import styled, { css } from "styled-components";

export const ProviderImgWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 70px;
	background: var(--casino-provider-gradient);
	margin: 20px 0;
	img {
		object-fit: contain;
		cursor: pointer;
	}

	.swiper {
		margin: 0;
	}

	.swiper-wrapper {
		padding-left: 2px;
	}

	.swiper-slide {
		width: auto !important;
		display: flex;
		width: 210px;
		min-width: 210px;
	}

	${({ colorful }) =>
		colorful &&
		css`
			background: transparent;

			${Won} {
				color: var(--secondary-color);
				text-align: center;
				font-size: 12px;
				font-weight: 600;
				line-height: 20px;
				letter-spacing: 0.3px;
			}

			${Name} {
				color: #e2e2e2;
				font-size: 10px;
				font-weight: 600;
				line-height: 12px;
				letter-spacing: 0.3px;
			}

			.swiper-slide {
				min-width: 110px;
				border-right: 1px solid #436466;
			}
		`}
`;

export const TenantWrapper = styled.div`
	display: flex;
	align-items: center;
	border-right: 0.844px solid var(--main-gradient);
	padding-right: 20px;

	svg {
		padding-left: 15px;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 10px;
	gap: 3px;
`;

export const Name = styled.div`
	display: flex;
	color: var(--gray-white, #fff);
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.633px;
`;

export const Won = styled.div`
	display: flex;
	color: var(--main-color);
	text-align: center;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 14px;
	letter-spacing: 0.253px;
`;

export const GameName = styled.div`
	display: flex;
	color: var(--gray-white, #fff);
	text-align: center;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-family: Roboto;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.633px;
`;
